/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconExpandMore/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconExpandMore({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconExpandMore",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconExpandMore.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z1izFM3': alignSelf,'--mt-2-Z1izFM3': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1izFM3': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1izFM3': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1izFM3': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1izFM3': opacity,'--w-10-Z1izFM3': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1izFM3': typeof height === 'number' ? `${height}px` : height,'--a-7-Z1izFM3': isAnimated ? animation : "none",'--sd-8-Z1izFM3': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1izFM3': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconExpandMore.SvgPath"
  data-view-path={viewPath}
 d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"
 style={{'--f-12-Z1izFM3': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}